import React from 'react';
import calendar from '@ingka/ssr-icon/paths/calendar';
import clipboard from '@ingka/ssr-icon/paths/clipboard';
import pieChart from '@ingka/ssr-icon/paths/pie-chart';
import barChart from '@ingka/ssr-icon/paths/bar-chart-uptrend';
import clock from '@ingka/ssr-icon/paths/clock';
import SSRIcon from '@ingka/ssr-icon';
import { env as appEnv } from 'utils/env';
import { Environment } from 'utils/environments';
import type { TFunction } from 'i18next';
import { OppLink } from 'types/routes';

const getEnvUrl = (env: Environment, prodUrl: string | undefined, demoUrl: string | undefined, ppeUrl: string | undefined): string => {
    if (env === Environment.PROD) {
        return prodUrl || '';
    }
    if (env === Environment.DEMO) {
        return demoUrl || '';
    }

    return ppeUrl || '';
};

const getOppLinks = ({ env, t }: { env: Environment, t: TFunction<'translation', undefined, 'translation'>, }): OppLink => ([
    {
        label: t('people_availability'),
        id: 0,
        href: env === Environment.PROD ? appEnv.VITE_APP_URLS_mia_opp_url : appEnv.VITE_APP_URLS_mia_ppe_opp_url,
        ssrIcon: () => <SSRIcon paths={calendar} />,
        icon: calendar,
        version: 1,
    },
    {
        label: t('task_management'),
        id: 1,
        href: env === Environment.PROD ? appEnv.VITE_APP_URLS_samla_opp_url : appEnv.VITE_APP_URLS_samla_ppe_opp_url,
        ssrIcon: () => <SSRIcon paths={clipboard} />,
        icon: clipboard,
        version: 1,
    },
    {
        label: t('people_capacity_planning'),
        id: 2,
        href: getEnvUrl(
            env,
            appEnv.VITE_APP_URLS_kappla_opp_url,
            appEnv.VITE_APP_URLS_kappla_demo_opp_url,
            appEnv.VITE_APP_URLS_kappla_ppe_opp_url
        ),
        ssrIcon: () => <SSRIcon paths={pieChart} />,
        icon: pieChart,
        version: 1,
    },
    {
        label: t('forecasting'),
        id: 3,
        href: env === Environment.PROD ? appEnv.VITE_APP_URLS_forecasting_opp_url : appEnv.VITE_APP_URLS_forecasting_ppe_opp_url,
        ssrIcon: () => <SSRIcon paths={barChart} />,
        icon: barChart,
        version: 1,
    },
    {
        label: t('workload_planning'),
        id: 4,
        href: getEnvUrl(
            env,
            appEnv.VITE_APP_URLS_workload_planning_opp_url,
            appEnv.VITE_APP_URLS_workload_planning_demo_opp_url,
            appEnv.VITE_APP_URLS_workload_planning_ppe_opp_url
        ),
        ssrIcon: () => <SSRIcon paths={clock} />,
        icon: clock,
        version: 1,
    },
    {
        label: t('hours_budgeting'),
        id: 5,
        href: getEnvUrl(
            env,
            appEnv.VITE_APP_URLS_budgeting_opp_url,
            appEnv.VITE_APP_URLS_budgeting_demo_opp_url,
            appEnv.VITE_APP_URLS_budgeting_ppe_opp_url
        ),
        ssrIcon: () => <SSRIcon paths={clock} />,
        icon: clock,
        version: 1,
    },
    {
        label: t('people_capacity_planning'),
        id: 6,
        href: getEnvUrl(
            env,
            appEnv.VITE_APP_URLS_kappla_opp_v2_url,
            appEnv.VITE_APP_URLS_kappla_demo_opp_v2_url,
            appEnv.VITE_APP_URLS_kappla_ppe_opp_v2_url
        ),
        ssrIcon: () => <SSRIcon paths={pieChart} />,
        icon: pieChart,
        version: 2,
    },
    {
        label: t('hours_budgeting'),
        id: 7,
        href: getEnvUrl(
            env,
            appEnv.VITE_APP_URLS_budgeting_opp_v2_url,
            appEnv.VITE_APP_URLS_budgeting_demo_opp_v2_url,
            appEnv.VITE_APP_URLS_budgeting_ppe_opp_v2_url
        ),
        ssrIcon: () => <SSRIcon paths={clock} />,
        icon: clock,
        version: 2,
    },
    {
        label: t('task_management'),
        id: 8,
        href: env === Environment.PROD ? appEnv.VITE_APP_URLS_samla_opp_v2_url : appEnv.VITE_APP_URLS_samla_ppe_opp_v2_url,
        ssrIcon: () => <SSRIcon paths={clipboard} />,
        icon: clipboard,
        version: 2,
    },
    {
        label: t('forecasting'),
        id: 9,
        href: env === Environment.PROD ? appEnv.VITE_APP_URLS_forecasting_opp_v2_url : appEnv.VITE_APP_URLS_forecasting_ppe_opp_v2_url,
        ssrIcon: () => <SSRIcon paths={barChart} />,
        icon: barChart,
        version: 2,
    },
]);

export default getOppLinks;
